import {
  require_jquery
} from "./chunk-CMYKXA3B.js";
import "./chunk-624QZG55.js";
export default require_jquery();
//# sourceMappingURL=jquery.js.map
